import { render } from "./Select.vue?vue&type=template&id=edbaabda"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"
script.render = render

export default script